/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteShiftSchedulesRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {DeleteShiftSchedulesResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const deleteShiftSchedules = (request: DeleteShiftSchedulesRequest, options?: CashRequestOptions) => post<DeleteShiftSchedulesRequest, DeleteShiftSchedulesResponse>("/2.0/cash/delete-shift-schedules", request, {...options, rejectOnError: true })